import { clsx } from 'clsx';
import { ComponentPropsWithoutRef, FC } from 'react';
import { S3UserImg } from '../s3/user/s3-img.tsx';
import { cardImg, cardImgContainer } from './cover-image.css.ts';

interface CoverImageProps extends ComponentPropsWithoutRef<'div'> {
  userId?: string;
  s3Key?: string;
  src?: string;
  aspectRatio?: number;
}

export const CoverImage: FC<CoverImageProps> = ({
  userId,
  s3Key,
  src,
  aspectRatio,
  className,
}) => {
  return (
    <div className={clsx(cardImgContainer, className)} style={{ aspectRatio }}>
      {s3Key && userId ? (
        <S3UserImg userId={userId} s3Key={s3Key} className={cardImg} />
      ) : src ? (
        <img src={src} className={cardImg} alt={'Cover'} />
      ) : null}
    </div>
  );
};
